module.exports = __webpack_public_path__ + "static/media/spinner.a9d1f19a.gif";